<template>
  <v-container>
    <v-card color="white">
      <v-layout row wrap>
        <v-flex xs8 offset-xs2>
          <p class="text-left pt-3 pb-3">Please provide all fields.</p>
          <v-form ref="form" v-model="valid" lazy-validation method="POST">
            <v-text-field
              background-color="grey lighten-5"
              color="primary"
              box
              clearable
              v-model="name"
              name="cname"
              :rules="[rules.required]"
              label="Name:"
              append-icon="account_circle"
              required
            ></v-text-field>
            <v-text-field
              background-color="grey lighten-5"
              color="primary"
              box
              clearable
              v-model="email"
              name="cemail"
              :rules="[rules.required]"
              label="Email:"
              append-icon="email"
              required
            ></v-text-field>
            <v-text-field
              background-color="grey lighten-5"
              color="primary"
              box
              clearable
              v-model="topic"
              name="topic"
              :rules="[rules.required]"
              label="Topic:"
              append-icon="format_quote"
              required
            ></v-text-field>
            <v-textarea
              background-color="grey lighten-5"
              color="primary"
              box
              clearable
              auto-grow
              rows="1"
              v-model="message"
              name="message"
              :rules="[rules.required]"
              append-icon="message"
              required
            >
              <div slot="label">
                Message:
              </div>
            </v-textarea>
            <v-layout row wrap>
              <v-flex xs6 offset-xs3>
                <v-btn
                  @click="construct"
                  color="info"
                  large
                  block
                  class="mt-3 mb-5"
                  >Contact Us</v-btn
                >
              </v-flex>
            </v-layout>
          </v-form>
        </v-flex>
      </v-layout>
    </v-card>
    <v-layout row wrap class="mt-3">
      <v-flex lg4 md4 xs12 sm12>
        <v-icon large>business</v-icon>
        <p>
          63 Spring St., Suite 201-A<br />
          Williamstown, MA, USA
        </p>
      </v-flex>
      <v-flex lg4 md4 xs12 sm12>
        <v-icon large>phone</v-icon>
        <p>512-554-5104</p>
      </v-flex>
      <v-flex lg4 md4 xs12 sm12>
        <v-icon large>mail_outlined</v-icon>
        <p>support@sustainesolutions.com</p>
      </v-flex>
    </v-layout>
    <a id="emailTrain" style="display:hidden;" />
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'Contact',
  // == Components
  // == Data
  data() {
    return {
      name: '',
      email: '',
      topic: '',
      message: '',
      valid: true,
      rules: {
        required: value => !!value || 'Field required'
      }
    }
  },
  // == Computed
  computed: {
    // the spread operator allows to merge these mappers with other local computed properties
    ...mapGetters(['getFacilityName'])
  },
  // == Methods
  methods: {
    /**
     * build the message
     */
    construct() {
      if (this.$refs.form.validate()) {
        let subj =
          'Message%20From%20the%20' + this.getFacilityName + '%20Facility'
        let body =
          "Hi.  I'm contacting you from the Sustaine application.\n\n" +
          '   Name:  ' +
          this.name +
          '\n' +
          '   Email:  ' +
          this.email +
          '\n' +
          '   Facility:  ' +
          this.getFacilityName +
          '\n\n' +
          '   Topic:  ' +
          this.topic +
          '\n' +
          '   Message:  ' +
          this.message +
          '\n\n\n' +
          'Thank you.\n\n'

        // TODO - make this a property
        let targetEmail = 'support@sustainesolutions.com'
        // get element, build out it's link, adn then 'click it'
        document.getElementById('emailTrain').href =
          'mailto:' +
          targetEmail +
          '?subject=' +
          subj +
          '&body=' +
          encodeURIComponent(body)
        document.getElementById('emailTrain').click()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.v-btn {
  background-color: #335b98 !important;
}
</style>
